const CRYPTO_CURRENCY_CODE = new Set([
  'IRT',
  'BTC',
  'ETH',
  'USDTE',
  'USDTT',
  'USDC',
  'DOGE',
  'USDT',
  'BCH',
  'LTC',
  'ADA',
  'TRX',
  'XRP',
  'NEO',
  'REP',
  'XIN',
  'BNB',
]);

export default CRYPTO_CURRENCY_CODE;
